<template>
    <div class="game-info card text-center">
        <div class="card-header">
            <ul class="nav nav-pills card-header-pills nav-fill">
                <button
                        :class="(activeSection === 'room' ? 'active': '')"
                        class="nav-item btn nav-link btn-sm"
                        v-on:click="activeSection = 'room'"
                >Room
                    <div class="room-id badge badge-dark" v-if="roomId">{{ roomId }}</div>
                </button>
                <button
                        :class="(activeSection === 'players' ? 'active': '')"
                        class="nav-item btn nav-link btn-sm"
                        v-on:click="activeSection = 'players'"
                >
                    Players
                    <div class="player-id badge badge-warning">{{ this.$gameClient.playerSessionId || 'Not connected' }}</div><br />
                    <div class="badge badge-dark"><i class="fas fa-user"></i> Users: {{ playerCount }}</div>
                </button>
                <button
                        :class="(activeSection === 'control' ? 'active': '')"
                        class="nav-item btn nav-link btn-sm"
                        v-on:click="activeSection = 'control'"
                >
                    Control
                </button>
            </ul>
        </div>
        <div v-if="activeSection === 'room'">
            <ThingToHtml
                    :button="false"
                    :thing="roomState"
                    class="room-state-thing"
                    theme="dark"
            ></ThingToHtml>
        </div>
        <div v-else-if="activeSection === 'players'">
            <player-slots></player-slots>
        </div>
        <div v-else-if="activeSection === 'control'">
            <button class="btn btn-danger" v-if="canReconnect" v-on:click="onReconnectClick">Reconnect ({{ reconnectId }})</button>
        </div>
    </div>
</template>

<script>
    import ThingToHtml from '@/lib/ThingToHtmlVue/index.vue'
    import PlayerSlots from './player-slots'
    import clone from 'clone'
    import LogItem from './log-item'
    import * as MutationTypes from '@/store/mutation-types'

    export default {
        components: {
            ThingToHtml,
            PlayerSlots,
            'log-item': LogItem,
        },
        data() {
            return {
                activeSection: 'room'
            }
        },
        methods: {
            onReconnectClick() {
                this.$store.commit(MutationTypes.SET_GAME_CLIENT_TRY_RECONNECT, true);

                this.$gameClient.disconnect();
            },
        },
        computed: {
            canReconnect() {
                return this.$gameClient.canReconnect();
            },
            reconnectId() {
                return this.$gameClient.getLastConnectedRoomId();
            },
            playerCount() {
                try {
                    return Object.keys(this.$gameClient.$state.players).length
                } catch (error) {
                    return 0
                }
            },
            logMessages() {
                try {
                    return this.$gameClient.logMessages
                } catch (error) {
                    return {}
                }
            },
            roomState() {
                try {
                    let roomState = clone(this.$gameClient.$state)

                    delete roomState.players

                    return roomState
                } catch (error) {
                    return []
                }
            },
            roomId() {
                try {
                    return this.$gameClient.$state.customId
                } catch (error) {
                    return null
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
    .player-slots {
        .nav-pills {
            .nav-item {
                a.disabled {
                    color: #888888 !important;
                }
            }
        }
    }
</style>
